import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Fade from 'react-reveal/Fade';

import NiaTVDevices from '../../static/img/home_page/devices_online_dance_workout_classes.webp';
import NiaTVQuote from '../../static/img/home_page/niatv_quote_online_dance_fitness.webp';
import NiaTVBackground from '../../static/img/home_page/niatv_online_dance_workouts.webp';

const styles = theme => ({
  section: {
    width: '100%',
    backgroundColor: 'white',
    position: 'relative',
    padding: theme.spacing(3),
    paddingTop: theme.spacing(5),
    paddingBottom: theme.spacing(5),
    margin: '0 auto',
  },
  content: {
    width: '100%',
    [theme.breakpoints.up(900)]: {
      width: '900px',
    },
    margin: '0 auto',
  },
  itemContainer: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    marginBottom: theme.spacing(5),
  },
  itemContainerRight: {
    padding: theme.spacing(2),
    paddingRight: theme.spacing(8),
  },
  sectionHeader: {
    paddingBottom: theme.spacing(2),
    letterSpacing: '5px',
    fontSize: 36,
  },
  sectionSubHeader: {
    paddingBottom: theme.spacing(2),
    letterSpacing: '5px',
    textTransform: 'uppercase',
    fontSize: 22,
  },
  sectionSubHeader1: {
    paddingBottom: theme.spacing(2),
    letterSpacing: '5px',
    textTransform: 'uppercase',
    fontSize: 24,
  },
  sectionText: {
    marginBottom: theme.spacing(),
    marginTop: theme.spacing(2),
    lineHeight: 1.8,
  },
  link: {
    textDecoration: 'none',
    color: 'white',
  },
  devicesImage: {
    maxWidth: '100%',
    height: 'auto',
    width: '320px',
    [theme.breakpoints.up(500)]: {
      width: '500px',
    },
  },
  actionArea: {
    textAlign: 'center',
    marginTop: theme.spacing(3),
  },
  action: {
    margin: theme.spacing(2),
  },
  quote: {
    width: '100%',
  },
  sectionSubtext: {
    color: 'white',
    marginBottom: theme.spacing(3),
  },
  subActionArea: {
    display: 'flex',
    justifyContent: 'flex-end',
    paddingRight: theme.spacing(10),
  },
  subAction: {
    margin: theme.spacing(2),
  },
  sec2Container: {
    marginLeft: theme.spacing(4),
    maxWidth: 500,
  },
  sec2Button: {
    marginTop: theme.spacing(3),
  },
  sec2TextContainer: {
    maxWidth: 300,
  },
  background: {
    marginTop: theme.spacing(3),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    backgroundImage: `url(${NiaTVBackground})`,
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    height: '100%',
    width: '100%',
    backgroundRepeat: 'no-repeat',
    borderLeft: '1px solid black',
  },
});

function GlobalSection(props) {
  const { classes } = props;
  return (
    <div className={classes.section}>
      <div className={classes.content}>
        <Grid container>
          <Grid item xs={12} md={7} className={classes.itemContainerLeft}>
            <Fade left>
              <img
                src={NiaTVDevices}
                alt="A smartphone, laptop, and desktop computer showing Nia’s online dance workout classes"
                className={classes.devicesImage}
                loading="lazy"
              />
            </Fade>
          </Grid>
          <Grid item xs={12} md={5} className={classes.itemContainerRight}>
            <Fade right>
              <Typography className={classes.sectionSubHeader1} color="textSecondary" variant="h2">STEP-IN TO NIA ...</Typography>
              <Typography className={classes.sectionHeader} color="textSecondary" variant="h2">ONLINE + ON-DEMAND</Typography>
              <Typography className={classes.sectionText}>Get fit and have fun the Body&#39;s Way with a subscription to Nia On Demand and get instant access to workout videos, meditations, music, podcasts and more. (14-day FREE trial period. Cancel anytime).</Typography>
              <div className={classes.actionArea}>
                <Button target="_blank" href="https://niaondemand.com" color="secondary" className={classes.action} variant="outlined">Get Moving</Button>
              </div>
            </Fade>
          </Grid>
          <Grid item xs={12}>
            <Fade left>
              <img
                src={NiaTVQuote}
                alt="A quote that says “workout anytime anywhere on any device” explaining that Nia’s online dance fitness classes are available anytime and anywhere"
                className={classes.quote}
                loading="lazy"
              />
            </Fade>
          </Grid>
          <Grid item xs={12} className={classes.background}>
            <div className={classes.sec2Container}>
              <Typography className={classes.sectionSubHeader} variant="h3">New Routines Release</Typography>
              <Typography className={classes.sectionSubHeader} variant="h3">Every 4 Months</Typography>
              <div className={classes.sec2TextContainer}>
                <Typography className={classes.sectionText}>We&#39;re dedicated to creating high-energy healing routines, online classes, and inspirational soundtracks to take your Fitness, Wellness, and Lifestyle to the next level.</Typography>
              </div>
              <Button color="secondary" variant="outlined" href="https://niaondemand.com/catalog" target="_blank" className={classes.sec2Button}>View Workouts</Button>
            </div>
          </Grid>
        </Grid>
      </div>
    </div>
  );
}

GlobalSection.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(GlobalSection);
